import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';

import { MockingService } from '../modules/core/services/response-mock.service';
import { constants } from '../constants/constants';

@Injectable()
export class ResponseMockInterceptor implements HttpInterceptor {
	constructor(private readonly _mockService: MockingService, private readonly _router: Router) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let serviceUrl = req.url;

		if (serviceUrl.indexOf('?') > -1) {
			serviceUrl = req.url.substring(0, serviceUrl.indexOf('?'));
		}

		if (serviceUrl.endsWith('/')) {
			serviceUrl = serviceUrl.slice(0, -1);
		}

		const timeoutMockMilliseconds = window.sessionStorage.getItem(constants.SESSION_STORAGE_KEYS.TIMEOUTMOCK_MILLISECONDS);
		if (timeoutMockMilliseconds) {
			return new Observable((observer: any) => {
				setTimeout(() => {
					window.sessionStorage.removeItem(constants.SESSION_STORAGE_KEYS.TIMEOUTMOCK_MILLISECONDS);
					next.handle(req).subscribe(payload => {
						observer.next(payload);
					});
				}, parseInt(timeoutMockMilliseconds, 10));
			});
		} else {
			const response = this._mockService.getResponse(serviceUrl);
			if (response) {
				return response();
			}
			return next.handle(req);
		}
	}
}
